var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 36,
    viewBox: "0 0 22 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.342285 0.208496V35.7918H7.45895V21.5585H14.5756C16.4631 21.5585 18.2732 20.8087 19.6079 19.4741C20.9425 18.1394 21.6923 16.3293 21.6923 14.4418V7.32516C21.6923 5.43771 20.9425 3.62755 19.6079 2.29292C18.2732 0.958285 16.4631 0.208496 14.5756 0.208496H0.342285ZM7.45895 7.32516H14.5756V14.4418H7.45895V7.32516Z",
    fill: "#00AEEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorp);
export default __webpack_public_path__ + "static/media/Vectorp.d5442cbc57c64c6206385951cbab8479.svg";
export { ForwardRef as ReactComponent };